window.globalHelpersModule.directive "confirmedRescheduleApproved", 
['$rootScope', '$log', '$timeout', '$filter', '$state', 'AuthService',
($rootScope, $log, $timeout, $filter, $state, AuthService) ->
  restrict: "E"
  scope:
    feedItem: "="
  link: (scope, element, attrs) ->
    scope.intakeFormLink = AuthService.getConfigData().INTAKE_URL + '/patient?route=patient/appointments&appointment_guid=' + scope.feedItem.scheduled_event_guid
    scope.intakeFormLinkText = 'Complete check-in'

    if scope.feedItem.submitted_at
      scope.intakeFormLinkText = 'Review check-in'

  templateUrl: 'portal/appointments/feed-items/confirmed_reschedule_approved/confirmed_reschedule_approved-directive-template.html'
]